import normalizeThreadDebugMode from '@/lib/normalizeThreadDebugMode.js';
import { normalizeThreadSandboxMode } from '@/lib/pieveComposerSettings.js';
import normalizeThreadComposerSettings from '@/lib/threads/normalizeThreadComposerSettings.js';
import normalizeThreadRecord from '@/lib/threads/normalizeThreadRecord.js';
import normalizeThreadType from '@/lib/threads/normalizeThreadType.js';

const normalizeCreatedThreadRecord = ({ value, projectId, sandboxMode, debugMode, composerModel, composerReasoningEffort, threadType } = {}) => {
  const candidate = value?.thread || value;
  const nowIso = new Date().toISOString();
  const normalizedThread = normalizeThreadRecord({
    value: candidate,
    fallbackProjectId: projectId,
    fallbackCreatedAtCandidates: [nowIso],
    fallbackUpdatedAtCandidates: [nowIso]
  });

  if (!normalizedThread) {
    return null;
  }

  const normalizedSandboxMode = normalizeThreadSandboxMode(candidate?.sandboxMode || candidate?.sandbox_mode || sandboxMode, '') || null;
  const normalizedDebugMode = normalizeThreadDebugMode(candidate?.debugMode || candidate?.debug_mode || debugMode, '') || null;
  const normalizedThreadType = normalizeThreadType(candidate?.threadType || candidate?.thread_type || threadType, 'default');
  const normalizedComposerSettings = normalizeThreadComposerSettings({
    model: candidate?.composerModel || composerModel,
    reasoning: candidate?.composerReasoningEffort || composerReasoningEffort
  });

  return {
    ...normalizedThread,
    ...(normalizedSandboxMode ? { sandboxMode: normalizedSandboxMode } : {}),
    ...(normalizedDebugMode ? { debugMode: normalizedDebugMode } : {}),
    threadType: normalizedThreadType,
    composerModel: normalizedComposerSettings.modelId,
    composerReasoningEffort: normalizedComposerSettings.reasoningEffort
  };
};

export default normalizeCreatedThreadRecord;
